(function () {
  'use strict';

  var initializedGuides = new WeakSet();

  function initializeGuide(guide) {
    if (!guide || initializedGuides.has(guide)) return;

    var dialog = guide.querySelector('[data-setup-guide-dialog]');
    var spotlight = guide.querySelector('[data-setup-guide-spotlight]');
    var steps = Array.prototype.slice.call(guide.querySelectorAll('[data-setup-guide-step]'));
    var count = guide.querySelector('[data-setup-guide-count]');
    var title = guide.querySelector('[data-setup-guide-title]');
    var copy = guide.querySelector('[data-setup-guide-copy]');
    var progress = Array.prototype.slice.call(guide.querySelectorAll('[data-setup-guide-progress] span'));
    var back = guide.querySelector('[data-setup-guide-back]');
    var next = guide.querySelector('[data-setup-guide-next]');
    var closeButtons = Array.prototype.slice.call(guide.querySelectorAll('[data-setup-guide-close]'));
    var trigger = document.querySelector('[aria-controls="' + guide.id + '"]');
    var currentIndex = 0;
    var currentTarget = null;
    var updateTimer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!dialog || !spotlight || !steps.length || !trigger) return;

    initializedGuides.add(guide);
    guide.dataset.initialized = 'true';

    function getFocusable() {
      return Array.prototype.slice.call(
        dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
      );
    }

    function positionGuide() {
      if (guide.hidden || !currentTarget) return;

      var rect = currentTarget.getBoundingClientRect();
      var padding = window.innerWidth < 750 ? 6 : 10;
      var top = Math.max(8, rect.top - padding);
      var left = Math.max(8, rect.left - padding);
      var right = Math.min(window.innerWidth - 8, rect.right + padding);
      var bottom = Math.min(window.innerHeight - 8, rect.bottom + padding);

      spotlight.style.top = top + 'px';
      spotlight.style.left = left + 'px';
      spotlight.style.width = Math.max(0, right - left) + 'px';
      spotlight.style.height = Math.max(0, bottom - top) + 'px';

      if (window.innerWidth < 750) {
        dialog.style.removeProperty('top');
        dialog.style.removeProperty('left');
        return;
      }

      var dialogRect = dialog.getBoundingClientRect();
      var dialogTop;

      if (window.innerHeight - bottom >= dialogRect.height + 18) {
        dialogTop = bottom + 12;
      } else if (top >= dialogRect.height + 18) {
        dialogTop = top - dialogRect.height - 12;
      } else {
        dialogTop = Math.max(16, window.innerHeight - dialogRect.height - 16);
      }

      var dialogLeft = Math.min(
        Math.max(16, left),
        window.innerWidth - dialogRect.width - 16
      );

      dialog.style.top = dialogTop + 'px';
      dialog.style.left = dialogLeft + 'px';
    }

    function cueChapter(target) {
      if (!target.matches('[data-hiw-step]')) return;
      target.click();
    }

    function showStep(index, shouldScroll) {
      var step = steps[index];
      var target = step ? document.querySelector(step.dataset.target) : null;

      if (!step || !target) return;

      currentIndex = index;
      currentTarget = target;
      count.textContent = 'Step ' + (index + 1) + ' of ' + steps.length;
      title.textContent = step.dataset.title || '';
      copy.textContent = step.dataset.copy || '';
      back.disabled = index === 0;
      next.textContent = index === steps.length - 1 ? 'Done' : 'Next';

      progress.forEach(function (item, progressIndex) {
        item.classList.toggle('is-active', progressIndex <= index);
      });

      cueChapter(target);

      if (shouldScroll !== false) {
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }

      window.clearTimeout(updateTimer);
      window.requestAnimationFrame(positionGuide);
      updateTimer = window.setTimeout(positionGuide, reduceMotion ? 20 : 420);
    }

    function openGuide() {
      guide.hidden = false;
      document.documentElement.classList.add('sf-setup-guide-open');
      showStep(0, true);
      window.setTimeout(function () {
        dialog.focus({ preventScroll: true });
      }, reduceMotion ? 20 : 440);
    }

    function closeGuide() {
      if (guide.hidden) return;
      guide.hidden = true;
      document.documentElement.classList.remove('sf-setup-guide-open');
      window.clearTimeout(updateTimer);
      trigger.focus({ preventScroll: true });
    }

    function handleKeydown(event) {
      if (guide.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeGuide();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable();
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    trigger.addEventListener('click', openGuide);
    back.addEventListener('click', function () {
      if (currentIndex > 0) showStep(currentIndex - 1, false);
    });
    next.addEventListener('click', function () {
      if (currentIndex >= steps.length - 1) {
        closeGuide();
        return;
      }
      showStep(currentIndex + 1, false);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeGuide);
    });
    guide.addEventListener('click', function (event) {
      if (event.target === guide) closeGuide();
    });
    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('resize', positionGuide);
    window.addEventListener('scroll', positionGuide, { passive: true });
  }

  function initializeAll() {
    document.querySelectorAll('[data-setup-guide]').forEach(initializeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);

  if (document.body) {
    new MutationObserver(function (mutations) {
      var guideAdded = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-setup-guide]') ||
            node.querySelector('[data-setup-guide]')
          );
        });
      });

      if (guideAdded) initializeAll();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
